import React from "react";
import DeleteButton from "components/deleteButton/deleteButton.js";
export default function TabButton(props) {
    const { tab, openedTab, onOpenedTabChange, onRemoveTab } = props;
    return (React.createElement("div", { key: tab.id, className: "window-tab-container" +
            (openedTab === tab.index ? " window-tab-container-open" : "") },
        React.createElement("button", { onClick: () => onOpenedTabChange(tab.index), className: "window-tab-opener" }, tab.title),
        React.createElement(DeleteButton, { variant: "cross", onClick: () => onRemoveTab(tab.index) })));
}
